// @ts-ignore
__webpack_nonce__ = window.__alfie_nonce__;
